import React from "react";

import useStore from "core/custom-hooks/useStore";

import Header from "components/Navigation/Header/Header";
import Popup from "components/Popup/Popup";
import Notification from "components/Notification/Notification";
import TzurPopup from "components/TzurPopup/TzurPopup";
import TzurPopupCenter from "components/TzurPopupCenter/TzurPopupCenter";

const LayoutWithoutSideBar = ({ children,isActive,isRRH }) => {
    const { state } = useStore();
    const { isMobileMenuOpen } = state;

    return (
        <div id="wrapper">
            <Popup />
            <TzurPopup />
            <TzurPopupCenter/>
            <Notification/>
            <Header isPreAuthentication={true}
            isActive={isActive}
            isRRH={isRRH}
            />
            <div className="main_content_container">
                <div>
                    {children}
                </div>
            </div>
           {isMobileMenuOpen && <div className="darken-mode"></div>}
        </div>
    );
};
export default LayoutWithoutSideBar;
